import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Table, Button, Col, Modal, Row, Container, Dropdown, Alert, Form, Spinner } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';
import ModalList from '../../components/Modals/ModalList';
import ModalEntityViewer from '../../components/Modals/ModalEntityViewer';
import ModalListPicker from '../../components/Modals/ModalListPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import moment from 'moment';
import { WriteXml } from 'fattura-elettronica';
import { settings } from '../settings';
import { Editor } from '@tinymce/tinymce-react';
import FieldPreview from '../../components/Entity/FieldPreview';



export default function DGLTH_supplier_order({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()


    function previewSupplierOrder(item) {
        navigate('/page/SupplierOrderPreview?id=' + item.id)
    }

    const [statusModalCheck, setStatusModalCheck] = useState(false)
    function closeModalCheck() {
        setStatusModalCheck(false)
    }
    function openModalCheck() {
        setStatusModalCheck(true)
    }

    const [showSendConfirmation, setShowSendConfirmation] = useState(false)
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false)

    function openSendConfirmationModal() {
        setShowSendConfirmation(true)
    }

    function closeSendConfirmationModal() {
        if (!isUpdatingStatus) {
            setShowSendConfirmation(false)
        }
    }

    async function confirmSendSupplierOrder() {
        if (!item?.id) {
            Swal.fire({ title: 'Errore', text: 'Ordine fornitore non valido.', icon: 'error', confirmButtonColor: '#dc3545' })
            return
        }

        try {
            setIsUpdatingStatus(true)
            const response = await DataManager.updateItem('supplier_order', { status: { value: '2_SENT', label: '2_SENT' } }, item.id)
            if (response.success === 1) {
                Swal.fire({ title: 'Completato', text: 'Ordine fornitore marcato come inviato.', icon: 'success', confirmButtonColor: '#198754' })
                let customerOrderId = null
                if (item?.idCustomerOrder) {
                    if (typeof item.idCustomerOrder === 'object' && item.idCustomerOrder !== null) {
                        customerOrderId = item.idCustomerOrder.id
                    }
                    else {
                        customerOrderId = item.idCustomerOrder
                    }
                }

                if (!customerOrderId) {
                    const supplierOrderDetails = await DataManager.getItem('supplier_order', item.id)
                    if (supplierOrderDetails.success === 1 && supplierOrderDetails.body && supplierOrderDetails.body.length > 0) {
                        const detail = supplierOrderDetails.body[0]
                        if (detail?.idCustomerOrder) {
                            if (typeof detail.idCustomerOrder === 'object') {
                                customerOrderId = detail.idCustomerOrder.id
                            }
                            else {
                                customerOrderId = detail.idCustomerOrder
                            }
                        }
                    }
                }

                if (customerOrderId) {
                    const constraints = [
                        {
                            fieldName: 'idCustomerOrder',
                            type: 'value',
                            value: customerOrderId
                        }
                    ]
                    const supplierOrdersResponse = await DataManager.searchItems('supplier_order', 1, 200, { field: 'id', order: 'ASC' }, '', [], constraints)
                    if (supplierOrdersResponse.success === 1 && Array.isArray(supplierOrdersResponse.body) && supplierOrdersResponse.body.length > 0) {
                        const allSent = supplierOrdersResponse.body.every((order) => {
                            const statusValue = typeof order.status === 'string' ? order.status : (order.status && order.status.value)
                            return statusValue === '2_SENT'
                        })

                        if (allSent) {
                            await DataManager.updateItem('customer_order', { status: { value: '1_ORDERED', label: '1_ORDERED' } }, customerOrderId)
                        }
                    }
                }

                setShowSendConfirmation(false)
                if (typeof refreshData === 'function') {
                    refreshData()
                }
            }
            else {
                Swal.fire({ title: 'Errore', text: response.message || 'Impossibile aggiornare lo stato.', icon: 'error', confirmButtonColor: '#dc3545' })
            }
        }
        catch (error) {
            Swal.fire({ title: 'Errore', text: error.message || 'Impossibile aggiornare lo stato.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
        finally {
            setIsUpdatingStatus(false)
        }
    }

    const [totConfirm, setTotConfirm] = useState(null)
    const [totRows, setTotRows] = useState(null)
    async function checkPrice() {
        var res = await DataManager.getItem('supplier_order', item.id);
        if (res.success === 1) {
            var temp = [];
            for (let i = 0; i < res.body[0].rows.length; i++) {
                temp.push(res.body[0].rows[i].idCustomerOrderRow);
            }

            var constraints1 = [
                { "fieldName": "id", type: "in", value: temp.toString() }
            ]
            var sorting1 = {
                'field': 'id',
                'order': 'desc'
            }
            var resp1 = await DataManager.searchItemsSimple('customer_order_row', 1, 200, sorting1, '', {}, constraints1);
            if (resp1.success === 1) {


                console.log(resp1)


                var so = res.body[0]
                var a = resp1.body.reduce((a, c) => a + parseFloat(c.totalPrice), 0);
                if (so.idSupplier.cash_flow_discount !== "0") {
                    console.log(a, so.idSupplier.cash_flow_discount)
                    a = parseFloat(a) - (parseFloat(a) * parseInt(so.idSupplier.cash_flow_discount) / 100)
                    console.log(a)
                }
                if (so.idSupplier.commercial_discount !== "0") {
                    console.log(a, so.idSupplier.commercial_discount)
                    a = parseFloat(a) - (parseFloat(a) * parseInt(so.idSupplier.commercial_discount) / 100)
                }


                if (so.files !== null) {
                    var b = so.files.reduce((acc, cur) => acc + parseFloat(cur.cost), 0);
                } else {
                    var b = parseFloat("0,00")
                }
                setTotConfirm(b)
                setTotRows(a)
                openModalCheck()
            }

        }
    }







    const [statusModalLocation, setStatusModalLocation] = useState(false)
    const [statusModalRows, setStatusModalRows] = useState(false)
    const [dataRows, setDataRows] = useState(false)
    const [customerRowsMap, setCustomerRowsMap] = useState({})
    const [loadingCustomerRows, setLoadingCustomerRows] = useState(false)
    const [statusModalReceive, setStatusModalReceive] = useState(false)
    const [receiveData, setReceiveData] = useState(null)
    const [selectedReceiveRows, setSelectedReceiveRows] = useState([])
    const [isReceiving, setIsReceiving] = useState(false)
    const selectAllReceiveRef = useRef(null)
    const [receiveRowNotes, setReceiveRowNotes] = useState({})

    const selectableReceiveRowIds = useMemo(() => {
        if (!receiveData || !Array.isArray(receiveData.rows)) {
            return []
        }
        return receiveData.rows
            .filter((row) => {
                if (!row || row.id === undefined || row.id === null) {
                    return false
                }
                const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                return statusValue !== '10_COMPLETED'
            })
            .map((row) => row.id)
    }, [receiveData])

    useEffect(() => {
        setSelectedReceiveRows((prev) => prev.filter((id) => selectableReceiveRowIds.includes(id)))
    }, [selectableReceiveRowIds])

    const allReceiveRowsSelected = selectableReceiveRowIds.length > 0 && selectableReceiveRowIds.every((id) => selectedReceiveRows.includes(id))
    const isSelectAllIndeterminate = selectedReceiveRows.length > 0 && !allReceiveRowsSelected

    useEffect(() => {
        if (selectAllReceiveRef.current) {
            selectAllReceiveRef.current.indeterminate = isSelectAllIndeterminate
        }
    }, [isSelectAllIndeterminate])


    function closeModalLocation() {
        setStatusModalLocation(false)
    }
    async function openModalLocation() {
        setStatusModalLocation(true)
    }


    function closeModalRows() {
        setStatusModalRows(false)
    }
    async function openModalRows() {
        const response = await DataManager.getItem('supplier_order', item.id)
        if (response.success === 1 && response.body && response.body.length > 0) {
            const order = response.body[0]
            setDataRows(order)
            setStatusModalRows(true)

            try {
                const rows = Array.isArray(order.rows) ? order.rows : []
                const ids = Array.from(new Set(rows.map(r => {
                    const ref = r && r.idCustomerOrderRow
                    if (typeof ref === 'object' && ref !== null) {
                        return ref.id
                    }
                    const num = typeof ref === 'number' ? ref : parseInt(ref, 10)
                    return Number.isNaN(num) ? null : num
                }).filter(Boolean)))

                if (ids.length > 0) {
                    setLoadingCustomerRows(true)
                    const map = {}
                    for (let i = 0; i < ids.length; i++) {
                        const id = ids[i]
                        try {
                            const res = await DataManager.getItem('customer_order_row', id)
                            if (res.success === 1 && res.body && res.body.length > 0) {
                                const row = res.body[0]
                                map[id] = row
                            }
                        } catch (e) {
                            // skip single failure
                        }
                    }
                    setCustomerRowsMap(map)
                }
                else {
                    setCustomerRowsMap({})
                }
            } catch (err) {
                setCustomerRowsMap({})
            } finally {
                setLoadingCustomerRows(false)
            }
        }
        else {
            Swal.fire({ title: 'Errore', text: response.message || 'Impossibile recuperare le righe dell\'ordine fornitore.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
    }

    async function openModalReceive() {
        const response = await DataManager.getItem('supplier_order', item.id)
        if (response.success === 1 && response.body && response.body.length > 0) {
            setReceiveData(response.body[0])
            setSelectedReceiveRows([])
            setIsReceiving(false)
            setReceiveRowNotes({})
            setStatusModalReceive(true)
        }
        else {
            Swal.fire({ title: 'Errore', text: response.message || 'Impossibile recuperare i dettagli ordine fornitore.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
    }

    function closeModalReceive() {
        setStatusModalReceive(false)
        setReceiveData(null)
        setSelectedReceiveRows([])
        setIsReceiving(false)
        setReceiveRowNotes({})
    }

    function handleReceiveRowNoteChange(rowId, value) {
        setReceiveRowNotes(prev => ({
            ...prev,
            [rowId]: value
        }))
    }

    const handleToggleAllReceiveRows = (checked) => {
        if (checked) {
            setSelectedReceiveRows(Array.from(selectableReceiveRowIds))
        }
        else {
            setSelectedReceiveRows([])
        }
    }

    const toggleReceiveRow = (rowId, checked) => {
        setSelectedReceiveRows(prev => {
            if (checked) {
                if (!selectableReceiveRowIds.includes(rowId)) {
                    return prev
                }
                if (prev.includes(rowId)) {
                    return prev
                }
                return [...prev, rowId]
            }
            return prev.filter(id => id !== rowId)
        })
    }

    async function confirmReceiveRows() {
        if (!receiveData || selectedReceiveRows.length === 0) {
            Swal.fire({ title: 'Attenzione', text: 'Seleziona almeno una riga ricevuta.', icon: 'warning', confirmButtonColor: '#ffc107' })
            return
        }

        try {
            setIsReceiving(true)

            for (let i = 0; i < selectedReceiveRows.length; i++) {
                const rowId = selectedReceiveRows[i]
                const supplierRow = receiveData.rows.find(r => r.id === rowId)
                if (!supplierRow) {
                    continue
                }

                const updateSupplierRow = await DataManager.updateItem('supplier_order_row', { status: { value: '2_ARRIVED', label: '2_ARRIVED' } }, rowId)
                if (updateSupplierRow.success !== 1) {
                    throw new Error(updateSupplierRow.message || 'Impossibile aggiornare la riga ordine fornitore.')
                }

                let orderRowId = null
                if (supplierRow.idCustomerOrderRow !== undefined && supplierRow.idCustomerOrderRow !== null) {
                    if (typeof supplierRow.idCustomerOrderRow === 'object') {
                        orderRowId = supplierRow.idCustomerOrderRow.id
                    }
                    else {
                        orderRowId = supplierRow.idCustomerOrderRow
                    }
                }
                if (orderRowId) {
                    const updateData = { status: { value: '10_RECEIVED', label: '10_RECEIVED' } }
                    // Add notes if provided
                    const rowNote = receiveRowNotes[rowId]
                    if (rowNote && rowNote.trim() !== '') {
                        updateData.notes = rowNote.trim()
                    }
                    const updateOrderRow = await DataManager.updateItem('customer_order_row', updateData, orderRowId)
                    if (updateOrderRow.success !== 1) {
                        throw new Error(updateOrderRow.message || 'Impossibile aggiornare la riga ordine cliente.')
                    }
                }
            }

            const refreshedSupplierOrder = await DataManager.getItem('supplier_order', item.id)
            if (refreshedSupplierOrder.success === 1 && refreshedSupplierOrder.body && refreshedSupplierOrder.body.length > 0) {
                const updatedSupplierOrder = refreshedSupplierOrder.body[0]
                const supplierRows = Array.isArray(updatedSupplierOrder.rows) ? updatedSupplierOrder.rows : []
                const allSupplierRowsReceived = supplierRows.length > 0 && supplierRows.every(row => {
                    const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                    return statusValue === '2_ARRIVED'
                })
                const supplierStatusValue = allSupplierRowsReceived ? '10_COMPLETED' : '5_PARTIAL'
                const supplierStatusLabel = allSupplierRowsReceived ? '10_COMPLETED' : '5_PARTIAL'

                const updateSupplierOrderStatus = await DataManager.updateItem('supplier_order', { status: { value: supplierStatusValue, label: supplierStatusLabel } }, item.id)
                if (updateSupplierOrderStatus.success !== 1) {
                    throw new Error(updateSupplierOrderStatus.message || 'Impossibile aggiornare lo stato dell\'ordine fornitore.')
                }

                const customerOrderId = updatedSupplierOrder.idCustomerOrder && updatedSupplierOrder.idCustomerOrder.id
                if (customerOrderId) {
                    const customerOrderResponse = await DataManager.getItem('customer_order', customerOrderId)
                    if (customerOrderResponse.success === 1 && customerOrderResponse.body && customerOrderResponse.body.length > 0) {
                        const customerOrder = customerOrderResponse.body[0]
                        const customerOrderRows = Array.isArray(customerOrder.rows) ? customerOrder.rows : []
                        const allCustomerRowsReady = customerOrderRows.length > 0 && customerOrderRows.every(row => {
                            const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                            return ['10_RECEIVED', '15_IN_DELIVERY', '20_DELIVERED'].includes(statusValue)
                        })

                        if (allCustomerRowsReady) {
                            const updateCustomerOrder = await DataManager.updateItem('customer_order', { status: { value: '7_READY_FOR_DELIVERY', label: '7_READY_FOR_DELIVERY' } }, customerOrder.id)
                            if (updateCustomerOrder.success !== 1) {
                                throw new Error(updateCustomerOrder.message || 'Impossibile aggiornare lo stato dell\'ordine cliente.')
                            }
                        }
                    }
                }
            }

            Swal.fire({ title: 'Completato', text: 'Righe ricevute correttamente.', icon: 'success', confirmButtonColor: '#198754' })
            closeModalReceive()
            if (typeof refreshData === 'function') {
                refreshData()
            }
        }
        catch (error) {
            Swal.fire({ title: 'Errore', text: error.message || 'Impossibile completare la ricezione.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
        finally {
            setIsReceiving(false)
        }
    }

    const [idArray, setIdArray] = useState([]);
    function toggleId(row) {
        const rawId = row && row.idCustomerOrderRow;
        const customerRowId = typeof rawId === 'number' ? rawId : parseInt(rawId, 10);

        if (!customerRowId || Number.isNaN(customerRowId)) {
            Swal.fire({ title: 'Attenzione', text: 'Riga cliente non disponibile per questa riga fornitore.', icon: 'warning', confirmButtonColor: '#ffc107' })
            return;
        }

        setIdArray(prev =>
            prev.includes(customerRowId)
                ? prev.filter(x => x !== customerRowId)
                : [...prev, customerRowId]
        )
    }

    async function selectRow(e) {
        console.log(e)
        closeModalLocation();
        closeModalRows()
        var body = {
            idLocation: { id: e.id }
        }
        var count = 0;
        for (let i = 0; i < idArray.length; i++) {
            var res = await DataManager.updateItem('customer_order_row', body, idArray[i])
            if (res.success === 1) {
                Swal.fire({ title: 'Completato', text: 'Locazione inserita con successo.', icon: 'success', confirmButtonColor: '#198754' })
                count++;
            } else {
                Swal.fire({ title: 'Errore', text: 'Errore.', icon: 'error', confirmButtonColor: '#dc3545' })
            }
        }
        if (count === idArray.length) {
            closeModalLocation();
            setIdArray([])
        } else {
            setIdArray([])
        }

    }



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample':
                            return (
                                <span>Test</span>
                            );
                        case 'gyv_supplier_order':
                            return (
                                <>
                                    {(item?.status?.value !== "1_TO_SEND" && item?.status?.value !== "2_SENT") ? <>
                                        <Button className='m-1' variant='outline-success' size='sm' onClick={() => openModalRows()}>Locazioni</Button>
                                    </> : <></>}
                                    {[0, 1].includes(LoginManager.getUserInfo()?.level) && (
                                        <Button className='m-1' variant='outline-secondary' size='sm' onClick={() => checkPrice()}>Confronta</Button>
                                    )}
                                    {item?.status?.value === '1_TO_SEND' ? (
                                        <Button className='m-1' variant='outline-primary' size='sm' onClick={openSendConfirmationModal}>Inviato</Button>
                                    ) : null}
                                    {item?.status?.value === '2_SENT' || item?.status?.value === '5_PARTIAL' ? (
                                        <Button className='m-1' variant='outline-primary' size='sm' onClick={() => openModalReceive()}>Ricevuto</Button>
                                    ) : null}
                                    <Button onClick={() => previewSupplierOrder(item)} size="sm" variant="outline-secondary" className='m-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>


                                    <Modal show={showSendConfirmation} onHide={closeSendConfirmationModal} backdrop={isUpdatingStatus ? 'static' : true} keyboard={!isUpdatingStatus}>
                                        <Modal.Header closeButton={!isUpdatingStatus}>
                                            <Modal.Title>Conferma invio ordine</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            Sei sicuro di voler impostare lo stato dell&apos;ordine fornitore su <strong>Inviato</strong>?
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant='secondary' onClick={closeSendConfirmationModal} disabled={isUpdatingStatus}>
                                                Annulla
                                            </Button>
                                            <Button variant='primary' onClick={confirmSendSupplierOrder} disabled={isUpdatingStatus}>
                                                {isUpdatingStatus ? 'Aggiornamento...' : 'Conferma'}
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>

                                    <Modal show={statusModalCheck} onHide={closeModalCheck}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Confronta</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Totale costo righe ordine cliente</p>
                                                    <h3>{parseFloat(totRows).toFixed(2)} €</h3>
                                                </Col>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Totale conferme d'ordine</p>
                                                    <h3>{parseFloat(totConfirm).toFixed(2)} €</h3>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col className='text-center'>
                                                    <h6>Differenza</h6>
                                                    <h2 className='text-success'>{parseFloat(totRows - totConfirm).toFixed(2)} €</h2>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                    </Modal>



                                    <Modal show={statusModalRows} onHide={closeModalRows} size='xl'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Locazione</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>

                                            <Row className='mb-3'>
                                                <Col>
                                                    {idArray && idArray.length > 0 ? <>
                                                        <Button variant='primary' onClick={() => openModalLocation()}>Seleziona locazione</Button>
                                                    </> : <Row>
                                                        <Col>
                                                            <h5>Seleziona una riga per procedere</h5>
                                                        </Col>
                                                    </Row>}
                                                </Col>

                                            </Row>
                                            {loadingCustomerRows ? (
                                                <Row className='mb-2'>
                                                    <Col>
                                                        <div className='d-flex align-items-center text-muted'>
                                                            <Spinner animation='border' size='sm' className='me-2' />
                                                            Caricamento locazioni...
                                                        </div>
                                                    </Col>
                                                </Row>
                                            ) : null}
                                            <Row>
                                                <Col>
                                                    <Table striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th>Nome</th>
                                                                <th>Descrizione</th>
                                                                <th>Quantità</th>
                                                                <th>Magazzino</th>
                                                                <th>Locazione</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Array.isArray(dataRows?.rows) && dataRows.rows.map((item, i) => {
                                                                const rawCustomerRowId = item?.idCustomerOrderRow;
                                                                const customerRowId = typeof rawCustomerRowId === 'number' ? rawCustomerRowId : parseInt(rawCustomerRowId, 10);
                                                                const hasCustomerRow = !Number.isNaN(customerRowId) && customerRowId;
                                                                const isChecked = hasCustomerRow ? idArray.includes(customerRowId) : false;
                                                                const customerRow = (typeof rawCustomerRowId === 'object' && rawCustomerRowId !== null)
                                                                    ? rawCustomerRowId
                                                                    : (customerRowsMap && hasCustomerRow ? customerRowsMap[customerRowId] : null);
                                                                const location = customerRow && customerRow.idLocation ? customerRow.idLocation : null;
                                                                const warehouseName = location && location.idWarehouse ? location.idWarehouse.name : null;
                                                                const locationName = location ? location.name : null;
                                                                return (
                                                                    <tr key={i}>
                                                                        <td>
                                                                            <Form.Check
                                                                                id={`supplier-row-${item.id}`}
                                                                                type="checkbox"
                                                                                disabled={!hasCustomerRow}
                                                                                checked={isChecked}
                                                                                onChange={() => toggleId(item)}
                                                                            />
                                                                        </td>
                                                                        <td>{item.name}</td>
                                                                        <td dangerouslySetInnerHTML={{ __html: item.description }}></td>
                                                                        <td>{item.quantity}</td>
                                                                        <td>{warehouseName || '-'}</td>
                                                                        <td>{locationName || '-'}</td>
                                                                    </tr>
                                                                )
                                                            })}

                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                    </Modal>



                                    <ModalListPicker entity={'location'} closeModal={closeModalLocation} modalStatus={statusModalLocation} selectRow={selectRow} />

                                    <Modal show={statusModalReceive} onHide={closeModalReceive} size='lg'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Righe ricevute</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            {receiveData && Array.isArray(receiveData.rows) && receiveData.rows.length > 0 ? (
                                                <Table striped bordered responsive>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: 40 }}>
                                                                <Form.Check
                                                                    ref={selectAllReceiveRef}
                                                                    type='checkbox'
                                                                    disabled={selectableReceiveRowIds.length === 0}
                                                                    checked={allReceiveRowsSelected}
                                                                    onChange={(event) => handleToggleAllReceiveRows(event.target.checked)}
                                                                />
                                                            </th>
                                                            <th>Articolo</th>
                                                            <th>Quantità</th>
                                                            <th>Stato</th>
                                                            <th>Note</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {receiveData.rows.map((row) => {
                                                            const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                                                            const isCompleted = statusValue === '10_COMPLETED'
                                                            return (
                                                                <tr key={row.id}>
                                                                    <td>
                                                                        <Form.Check
                                                                            type='checkbox'
                                                                            disabled={isCompleted}
                                                                            checked={selectedReceiveRows.includes(row.id)}
                                                                            onChange={(event) => toggleReceiveRow(row.id, event.target.checked)}
                                                                        />
                                                                    </td>
                                                                    <td>{row.name || '-'}</td>
                                                                    <td>{row.quantity ?? 0}</td>
                                                                    <td>{statusValue ? LanguageProvider.getLabel('supplier_order_row', `status.options.${statusValue}`) : '-'}</td>
                                                                    <td>
                                                                        <Form.Control
                                                                            as='textarea'
                                                                            rows={2}
                                                                            placeholder='Inserisci note...'
                                                                            disabled={isCompleted}
                                                                            value={receiveRowNotes[row.id] || ''}
                                                                            onChange={(e) => handleReceiveRowNoteChange(row.id, e.target.value)}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <Alert variant='secondary'>Nessuna riga disponibile.</Alert>
                                            )}
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant='secondary' onClick={closeModalReceive}>Annulla</Button>
                                            <Button variant='primary' onClick={confirmReceiveRows} disabled={isReceiving || selectedReceiveRows.length === 0}>Conferma ricezione</Button>
                                        </Modal.Footer>
                                    </Modal>
                                </>
                            );
                        default:
                            return (
                                <></>
                            );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
